// extracted by mini-css-extract-plugin
export default {"outerWrapper":"INZDm___NotFound-module__outerWrapper","wrapper":"j9F52___NotFound-module__wrapper"};